import { isProduction } from "./env";
/**
 * Only change this line
 */
var addressToImpersonate = undefined;
/**
 * Do not change this line
 * This ensure only development get impersonate account
 */
export var impersonateAddress = !isProduction()
    ? addressToImpersonate
    : undefined;
//# sourceMappingURL=development.js.map